import { createContext, type ReactNode, useContext, useState, useSyncExternalStore } from 'react';

import { KeyboardShortcutsDialog } from './components/keyboard-shortcuts-dialog';
import { useKeyboardShortcuts } from './components/keyboard-shortcuts-provider';

interface KeyboardShortcutDialogContextType {
  isKeyboardShortcutsOpen: boolean;
  setIsKeyboardShortcutsOpen: (isKeyboardShortcutsOpen: boolean) => void;
}

const KeyboardShortcutDialogContext = createContext<KeyboardShortcutDialogContextType>({
  isKeyboardShortcutsOpen: false,
  setIsKeyboardShortcutsOpen: () => {},
});

export function KeyboardShortcutDialogProvider({ children }: { children: ReactNode }) {
  const [isKeyboardShortcutsOpen, setIsKeyboardShortcutsOpen] = useState(false);

  return (
    <KeyboardShortcutDialogContext.Provider value={{ isKeyboardShortcutsOpen, setIsKeyboardShortcutsOpen }}>
      {children}
      <KeyboardShortcutsDialogSubscription isOpen={isKeyboardShortcutsOpen} onOpenChange={setIsKeyboardShortcutsOpen} />
    </KeyboardShortcutDialogContext.Provider>
  );
}

function KeyboardShortcutsDialogSubscription({
  isOpen,
  onOpenChange,
}: {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
}) {
  const shortcuts = useKeyboardShortcuts();
  const activeShortcuts = useSyncExternalStore(
    shortcuts.subscribe,
    shortcuts.getActiveShortcuts,
    shortcuts.getActiveShortcuts,
  );

  return <KeyboardShortcutsDialog isOpen={isOpen} onOpenChange={onOpenChange} shortcuts={activeShortcuts} />;
}

export function useKeyboardShortcutDialog(): {
  isKeyboardShortcutsOpen: boolean;
  setIsKeyboardShortcutsOpen: (isKeyboardShortcutsOpen: boolean) => void;
} {
  return useContext(KeyboardShortcutDialogContext);
}
